import clsx from 'clsx';
import React from 'react';

import TagPill from './Elements/TagPill';
import { TagType } from './types';

interface AssignedTagsGridProps {
  assignedTags: TagType[];
  tagInput: string;
  onRemoveTag: (label: string) => void; // Delete menu: remove from project
  onUnassignTag?: (label: string) => void; // X button: unassign from file
  onRestoreSuggestion: (label: string) => void;
  onEditTag?: (tag: TagType) => void;
  isTagReadOnly?: boolean;
  setAssignedTags?: (tags: TagType[]) => void;
}

const AssignedTagsGrid: React.FC<AssignedTagsGridProps> = ({
  assignedTags,
  onRemoveTag,
  onUnassignTag,
  onRestoreSuggestion,
  onEditTag,
  isTagReadOnly = false,
  setAssignedTags,
}) => {
  const safeAssignedTags = Array.isArray(assignedTags) ? assignedTags : [];
  return (
    <div
      className={clsx(
        'tw-flex',
        'tw-flex-wrap',
        'tw-gap-2',
        'tw-mb-3',
        'tw-max-h-[144px]',
        'tw-overflow-y-auto',
        'tw-w-full'
      )}
      style={{ flexWrap: 'wrap', gap: '8px', width: '100%' }}
    >
      {safeAssignedTags.map((tag) => (
        <TagPill
          key={tag.name}
          tag={tag}
          color={tag.color}
          className={clsx(
            'tw-px-3',
            'tw-py-1',
            'tw-rounded-full',
            'tw-text-sm',
            'tw-flex',
            'tw-items-center',
            'tw-gap-1',
            tag.color
          )}
          removable={true}
          onRemove={() => {
            if (onUnassignTag) {
              onUnassignTag(tag.name); // X button: unassign from file
              if (setAssignedTags) {
                const newTags = safeAssignedTags.filter((t) => t.name !== tag.name);
                setAssignedTags(newTags);
              }
            }
            onRestoreSuggestion(tag.name);
          }}
          onDelete={() => {
            onRemoveTag(tag.name); // Delete menu: remove from project
            if (setAssignedTags) {
              const newTags = safeAssignedTags.filter((t) => t.name !== tag.name);
              setAssignedTags(newTags);
            }
            onRestoreSuggestion(tag.name);
          }}
          onEdit={onEditTag ? () => onEditTag(tag) : undefined}
          style={{
            cursor: 'pointer',
            backgroundColor: tag.color || '#ffffff',
            minWidth: 60,
            maxWidth: 90,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: '0 1 auto',
          }}
          isTagReadOnly={isTagReadOnly}
        />
      ))}
    </div>
  );
};

export default AssignedTagsGrid;
